import { Avatar as BaseAvatar } from '@base-ui/react/avatar';
import { getInitials } from './getInitials.js';

/** A person's photo, or their initials while it loads or when there is none. */
const Avatar = ({ name, src, size = 'md' }) => {
  return (
    <BaseAvatar.Root className={`comp-avatar comp-avatar--${size}`}>
      {src && <BaseAvatar.Image src={src} alt={name} className="comp-avatar__image" />}
      <BaseAvatar.Fallback className="comp-avatar__fallback" aria-label={name} role="img">
        {getInitials(name)}
      </BaseAvatar.Fallback>
    </BaseAvatar.Root>
  );
};

export default Avatar;
